import { CircularProgress } from '@mui/material';
import { filterUndefined } from '../../utils/FilterUndefinedObject';
import './LoadingSpinner.scss';

const defaultProps = {
  message: '',
};

const LoadingSpinner = (props) => {
  const { message } = { ...defaultProps, ...filterUndefined(props) };
  return (
    <div className='loading-spinner-loading'>
      <CircularProgress size={40} />
      <div className='loading-message' data-dd-privacy='mask'>
        {message}
      </div>
    </div>
  );
};

export default LoadingSpinner;
